import { render, staticRenderFns } from "./GroupField.vue?vue&type=template&id=e170c7c2&scoped=true"
import script from "./GroupField.vue?vue&type=script&lang=js"
export * from "./GroupField.vue?vue&type=script&lang=js"
import style0 from "./GroupField.vue?vue&type=style&index=0&id=e170c7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e170c7c2",
  null
  
)

export default component.exports